import { jsx as l } from "react/jsx-runtime";
import { MDCLineRippleFoundation as c } from "@material/line-ripple";
import { useFoundation as d, createComponent as m, Tag as u } from "@rmwc/base";
import { useEffect as o } from "react";
const v = (a) => {
  const { foundation: t, ...s } = d({
    props: a,
    elements: {
      rootEl: !0
    },
    foundation: ({ rootEl: n }) => new c({
      addClass: (e) => n.addClass(e),
      removeClass: (e) => n.removeClass(e),
      hasClass: (e) => n.hasClass(e),
      setStyle: (e, i) => n.setStyle(e, i),
      registerEventHandler: (e, i) => n.addEventListener(e, i),
      deregisterEventHandler: (e, i) => n.removeEventListener(e, i)
    })
  }), { rootEl: r } = s;
  return o(() => {
    a.active ? t.activate() : t.deactivate();
  }, [a.active, t]), o(() => {
    typeof a.center == "number" && t.setRippleCenter(a.center);
  }, [a.center, t]), r.setProp(
    "onTransitionEnd",
    (n) => t.handleTransitionEnd(n),
    !0
  ), { foundation: t, ...s };
}, L = m(
  function(t, s) {
    const { active: r, center: n, ...e } = t, { rootEl: i } = v(t);
    return /* @__PURE__ */ l(
      u,
      {
        ...e,
        tag: "span",
        element: i,
        className: "mdc-line-ripple",
        ref: s
      }
    );
  }
);
export {
  L as LineRipple
};
